import { render, staticRenderFns } from "./projectaddorupdate.vue?vue&type=template&id=681edfc0"
import script from "./projectaddorupdate.vue?vue&type=script&lang=js"
export * from "./projectaddorupdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports